/* eslint-disable */
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { useEffect, useState } from "react";
import { saveCondicionFrenteIva } from "../../services/CondicionFrenteIvaService";
import WaitingDialog from "../../utils/WaitingDialog";

const initialState = {
  descripcion: "",
  descripcionCorta: "",
  codigoAfip: "",
  disponibleFacturacionCobranza: "no",
  observaciones: "",
};

const disponibleFacturacionCobranzaOptions = [
  {
    id: "si",
    descripcion: "SI",
  },
  {
    id: "no",
    descripcion: "NO",
  },
];

const nameItemText = "Condición frente al IVA";
const itemGender = "F";
//
// ########################################################################### 
//
const CondicionFrenteIvaDialog = ({
  onSave,
  onClose,
  itemCrud,
  actionCrud,
  setMessage,
  setShowMessage,
}) => {
  const [itemCrudLocal, setItemCrudLocal] = useState(initialState);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  //
  // ################################################################################
  //
  useEffect(() => {
    if (actionCrud === "new") {
      setItemCrudLocal(initialState);
    } else {
      setItemCrudLocal(itemCrud);
    }
  }, []);
  //
  // ################################################################################
  //
  const handleCloseDialog = () => {
    onClose();
  };
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setItemCrudLocal({
      ...itemCrudLocal,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleSave = () => {
    if (actionCrud === "new" || actionCrud === "update") {

      if (itemCrudLocal.descripcion === "") {
        setMessage({
          severity: "error",
          messageText: "Debes ingresar la descripción de la Condición frente al IVA",
        });
        setShowMessage(true);
        return;
      }

      if (itemCrudLocal.descripcionCorta === "") {
        setMessage({
          severity: "error",
          messageText: "Debes ingresar la descripción corta de la Condición frente al IVA",
        });
        setShowMessage(true);
        return;
      }
    }

    save();
  };
  //
  // ########################################################################## 
  //
  const save = async () => {
    let _itemCrud = {
      descripcion: itemCrudLocal.descripcion,
      descripcion_corta: itemCrudLocal.descripcionCorta,
      codigo_afip: itemCrudLocal.codigoAfip,
      disponible_facturacion_cobranza: itemCrudLocal.disponibleFacturacionCobranza === "si" ? true : false,
      observaciones: itemCrudLocal.observaciones,
    };
    if (actionCrud !== "new") {
      _itemCrud.id = itemCrudLocal.id;
    }

    setIsDoingSomething(true);
    const response = await saveCondicionFrenteIva(actionCrud, _itemCrud);
    setIsDoingSomething(false);

    if (response.ok) {
      onSave();
    }

    setMessage({
      messageText: response.messageText,
      severity: response.messageSeverity,
    });
    setShowMessage(true);
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Dialog
        open={true}
        onClose={(event, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
            return;
          }
          handleCloseDialog();
        }}
        disableEscapeKeyDown={true}
        maxWidth="sm"
        fullWidth={true}
        scroll="paper"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {actionCrud === "new"
            ? itemGender === "M"
              ? "Nuevo"
              : "Nueva"
            : actionCrud === "update"
              ? "Editando"
              : actionCrud === "enable"
                ? "Habilitando"
                : "Deshabilitando"}{" "}
          {nameItemText}
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                }}
                id="descripcion"
                label="Descripción"
                variant="outlined"
                size="small"
                name="descripcion"
                value={itemCrudLocal.descripcion}
                onChange={handleChange}
                disabled={actionCrud === "view" || actionCrud === "enable" || actionCrud === "disable"}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                }}
                id="descripcionCorta"
                label="Descripción Corta"
                variant="outlined"
                size="small"
                name="descripcionCorta"
                value={itemCrudLocal.descripcionCorta}
                onChange={handleChange}
                disabled={actionCrud === "view" || actionCrud === "enable" || actionCrud === "disable"}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                }}
                id="codigoAfip"
                label="Código AFIP"
                variant="outlined"
                size="small"
                name="codigoAfip"
                value={itemCrudLocal.codigoAfip}
                onChange={handleChange}
                disabled={actionCrud === "view" || actionCrud === "enable" || actionCrud === "disable"}
              />
            </Grid>

            <Grid item xs={12}>
              <FormControl sx={{ width: "100%" }}>
                <InputLabel id="disponible-facturacion-cobranza-select-label">
                  Disponible para Facturación y Cobranza
                </InputLabel>
                <Select
                  labelId="disponible-facturacion-cobranza-select-label"
                  id="disponible-facturacion-cobranza"
                  name="disponibleFacturacionCobranza"
                  value={itemCrudLocal.disponibleFacturacionCobranza || ""}
                  label="Disponible para Facturación y Cobranza"
                  size="small"
                  onChange={handleChange}
                  MenuProps={{ style: { maxHeight: "300px" } }}
                  disabled={actionCrud === "disable" || actionCrud === "enable"}
                >
                  {disponibleFacturacionCobranzaOptions.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.descripcion}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                inputProps={{
                  autoComplete: "off"
                }}
                id="observaciones"
                label="Observaciones"
                variant="outlined"
                name="observaciones"
                value={itemCrudLocal.observaciones}
                onChange={handleChange}
                disabled={actionCrud === "view" || actionCrud === "enable" || actionCrud === "disable"}
                multiline
                rows={3}
                sx={{
                  "& .MuiInputBase-root": {
                    minHeight: '80px'
                  }
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Box
                sx={{ display: "flex", justifyContent: "flex-end", pt: 1 }}
              >
                <Button
                  sx={{ mr: 1 }}
                  variant="contained"
                  size="small"
                  onClick={handleSave}
                  color={actionCrud === "disable" ? "error" : "primary"}
                  startIcon={
                    actionCrud === "disable" ? (
                      <RemoveCircleOutlineIcon />
                    ) : actionCrud === "enable" ? (
                      <AddCircleOutlineIcon />
                    ) : (
                      <SaveIcon />
                    )
                  }
                >
                  {actionCrud === "disable"
                    ? "Deshabilitar"
                    : actionCrud === "enable"
                      ? "Habilitar"
                      : "Guardar"}
                </Button>

                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleCloseDialog}
                >
                  Cancelar
                </Button>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default CondicionFrenteIvaDialog;
